import React from "react"
import Header from "./Header"
import Footer from "./Footer"

function Layer({ children }) {
  return (
    <div className="wrapper">
      <Header />
      {children}
      <Footer />
    </div>
  )
}

export default Layer
